import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';

export class TransportRegistrationInstructionsController extends AbstractStepController {

    nextControl = new StepControl();
    previousControl = new StepControl();

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === TerminalContextConstants.transportInstructionsValidityState) {
            this.nextControl.disabled = !contextChange.value;
        }
        if (contextChange.key === TerminalContextConstants.transportInstructionsDetailsShownState) {
            this.previousControl.disabled = contextChange.value;
        }
    }

    onRegisterToDashboardContext() {
        this.nextControl.disabled = this.dashboardContext.getContextValue(TerminalContextConstants.transportInstructionsValidityState)
            !== true;
        this.previousControl.disabled = this.dashboardContext.getContextValue(TerminalContextConstants.transportInstructionsDetailsShownState)
            === true;
    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('instructions started');

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {
        const matDialog = WizardServiceLocator.injector.get(MatDialog);
        const dialogData: ConfirmDialogData = {
            titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
            messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
            confirm: () => {
                this.wizardComponent.stopInactivityMonitoring();
                this.wizardComponent.restartWizard();
            }
        };
        matDialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        this.previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
        this.previousControl.type = StepControlType.BUTTON_STROKED;
        this.previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
        this.previousControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.previous();
        };
        controls.push(this.previousControl);

        var spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const cancelControl = new StepControl();
        cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
        cancelControl.type = StepControlType.BUTTON_STROKED;
        cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
        cancelControl.controlAction = this.cancel.bind(this);
        controls.push(cancelControl);

        var spacer = new StepControl();
        spacer.type = StepControlType.SPACER;
        controls.push(spacer);

        // tmc-yard.widgets.registration-terminal.button.finish-registration
        this.nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';
        this.nextControl.type = StepControlType.BUTTON;
        this.nextControl.iconAfterCss = 'fa-thin fa-angle-right';
        this.nextControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.next();
        };
        controls.push(this.nextControl);

        return controls;
    }
}
